import React from 'react';
import { MenuItem as MuiMenuItem, ListItemText as MuiListItemText, ListItemIcon as MuiListItemIcon, } from '@mui/material';
import clsx from 'clsx';
import { omit } from 'lodash-es';
import { dropdownClasses } from './style';
import OverflowWrapper from '../../Shared/OverflowWrapper';
function parseExtendProps(itemData) {
    let extendProps = {};
    Object.keys(itemData).forEach((key) => {
        if (['href', 'target', 'role'].includes(key) || key.startsWith('aria-')) {
            extendProps[key] = itemData?.[key];
        }
    });
    if (itemData.disabled && itemData.href) {
        extendProps = omit(extendProps, 'href');
    }
    return extendProps;
}
const MenuItem = React.forwardRef((props, ref) => {
    const { type, children, prefixIcon, suffixIcon, expend, onRequestSubItems, danger, itemData, onMounted, ...restProps } = props;
    return (React.createElement(MuiMenuItem, { ref: ref, onMouseEnter: () => onRequestSubItems?.(undefined), ...parseExtendProps(itemData), ...restProps, ...(type === 'link' ? { component: 'a' } : {}), disableRipple: true, classes: {
            root: clsx(dropdownClasses.menuItem, props.className),
            disabled: dropdownClasses.menuItemDisabled,
            selected: dropdownClasses.menuItemSelected,
        }, className: clsx({
            [dropdownClasses.menuItemExpend]: expend,
            [dropdownClasses.menuItemDanger]: danger,
        }) },
        prefixIcon && (React.createElement(MuiListItemIcon, { className: dropdownClasses.menuItemPrefix, "aria-hidden": "true" }, prefixIcon)),
        React.createElement(OverflowWrapper, { component: MuiListItemText, className: dropdownClasses.menuItemText, onMounted: onMounted }, children),
        suffixIcon && (React.createElement(MuiListItemIcon, { className: dropdownClasses.menuItemSuffix, "aria-hidden": "true" }, suffixIcon))));
});
export default MenuItem;
